import { cn } from '../../utils/cn';

interface SpinnerProps {
  /** Spinner size variant */
  size?: 'xs' | 'sm' | 'md' | 'lg';
  /** Additional CSS classes (use to override color, e.g. `text-error`) */
  className?: string;
}

const sizeStyles: Record<NonNullable<SpinnerProps['size']>, string> = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

/**
 * SVG-based loading spinner with infinite rotation.
 *
 * Uses `currentColor` so the color is inherited from the parent or
 * overridden via Tailwind text-color utilities in `className`.
 * Default color comes from `text-accent-500`.
 *
 * Accessible: announces "Loading" via `aria-label` + `role="status"`.
 */
export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span role="status" className="inline-flex items-center">
      <svg
        className={cn('animate-spin text-accent-500', sizeStyles[size], className)}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
      <span className="sr-only">Carregando</span>
    </span>
  );
}

export default Spinner;
